import React from "react";
import { DocusealForm } from "@docuseal/react";
import WizardProvider from "../context/WizardContext";
import DynamicModal, {
	WizardButtons,
} from "../../../components/modals/DynamicModal";
import { FormProvider, useForm } from "react-hook-form";
import { Card } from "reactstrap";

const SignInHouseModal = ({
	buyerLink = null,
	cobuyerLink = null,
	dealerLink = null,
	modal,
	toggle,
}) => {
	// Define form validation parameters
	const methods = useForm({
		reValidateMode: "onBlur",
	});

	const components = [
		buyerLink && (
			<Card>
				<DocusealForm src={buyerLink} customCss={style} withTitle={false} />
			</Card>
		),
		cobuyerLink && (
			<Card>
				<DocusealForm src={cobuyerLink} customCss={style} withTitle={false} />
			</Card>
		),
		dealerLink && (
			<Card>
				<DocusealForm src={dealerLink} customCss={style} withTitle={false} />
			</Card>
		),
	].filter(Boolean);

	return (
		<WizardProvider>
			<DynamicModal
				modalTitle="eSign Wizard"
				components={components}
				toggle={toggle}
				modal={modal}
				children={
					<FormProvider {...methods}>
						<WizardButtons submit={toggle} />
					</FormProvider>
				}
			/>
		</WizardProvider>
	);
};

export default SignInHouseModal;

const style = `/* Text elements in the completed form */
    .completed-form-message-title,
    .completed-form-message-body {
        color: #000000;
    }
    
    /*
        The company logo displayed in the start form.
        This affects both the company and DocuSeal logos if a custom company logo is not provided.
      */
    .start-form-company-logo {
        background-color: #000000;
        border-radius: 0.25rem;
    }
    
    /* Document title displayed at the top of the form */
    .template-title {
        color: #000000;
    }
    
    /*
        The company logo displayed in the submitted form.
        Affects both the company and DocuSeal logos if a custom company logo is not provided.
      */
    .submitted-form-company-logo {
        background-color: #ffffff;
        border-radius: 0.25rem;
    }
    
    /* Titles, descriptions, and text elements in the submitted form */
    .field-name-label,
    .field-description-text,
    .submitted-form-title,
    .submitted-form-template-title,
    .submitted-form-template-description {
        color: #000000;
    }
    `;
